import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import MomentTZ from 'moment-timezone';
import SearchBox from '../../components/searchBox/SearchBox';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';
import { Redirect } from 'react-router-dom';
import { fetchLoader } from '../utils/FetchLoader';
import { withCookies, Cookies } from 'react-cookie';
import Features from '../../const/Features';
import FeatureService from './../../services/feature/FeatureService.js';
import Listener from '../../const/Listener';
import ErrorsCodes from '../../const/ErrorsCodes';
import FlightHistoryService from '../../services/flightHistory/FlightHistoryService';
import EventEmitter from '../modules/event-emitter/EventEmitter';
import { isFromCallcenter } from '../../services/queryService/QueryService';

const I18n = require('i18n-react').default;
var GET_AVAILABILITY_V1 = 'catalog/api/v1/availability?';
var GET_AIRPORTS_V1 = 'catalog/api/v1/airport?';
var PREVIOUS_VISIT_COOKIE = 'previousVisit';

const propTypes = {
  typeTrip: PropTypes.string,
  flightOrigin: PropTypes.object,
  flightDestiny: PropTypes.object,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  totalAdults: PropTypes.number,
  totalKids: PropTypes.number,
  totalBabys: PropTypes.number,
  cabinCategory: PropTypes.string,
  typeOfFlight: PropTypes.string,
  companiesIdentity: PropTypes.string,
  loadRecentFlight: PropTypes.func,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  location: PropTypes.object.isRequired,
  callbackCallcenterMode: PropTypes.func
};

const defaultProps = {
  typeTrip: 'roundTrip',
  flightOrigin: null,
  flightDestiny: null,
  startDate: null,
  endDate: null,
  totalAdults: Number(1),
  totalKids: Number(0),
  totalBabys: Number(0),
  cabinCategory: 'ECONOMY',
  typeOfFlight: '',
  companiesIdentity: ''
};

class SearchBoxContainer extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      openModal: false,
      messageInfo: null,
      result: {},
      isRedirect: false,
      recentFlights: [],
      filterTypeTrip: props.typeTrip,
      filterFlightOrigin: props.flightOrigin,
      filterFlightDestiny: props.flightDestiny,
      filterStartDate: props.startDate,
      filterEndDate: props.endDate,
      filterTotalAdults: props.totalAdults,
      filterTotalKids: props.totalKids,
      filterTotalBabys: props.totalBabys,
      filterCabinCategory: props.cabinCategory,
      filterTypeOfFlight: props.typeOfFlight,
      filterCompaniesIdentity: props.companiesIdentity,
      sendDateWithTimeZone: false,
      isFlightHistoryEnabled: false,
      urlRedirect: '/',
      isSearchDeeplinkEnabled: false,
      modalInactivity: false,
      isCallcenterEnabled: false
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleAirportSearch = this.handleAirportSearch.bind(this);
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.getRecentFlights = this.getRecentFlights.bind(this);
    this.updateCookies = this.updateCookies.bind(this);
  }

  componentWillMount() {
    this.setState({
      updateHistoryListener: EventEmitter.createListener(
        Listener.FLIGHT_HISTORY_SERVICE,
        this.handleRecentFlights
      ),
      modalInactivityListener: EventEmitter.createListener(
        Listener.SHOW_MODAL_INACTIVITY,
        this.showModalInactivity
      )
    });

    this.fillCallCenterModeFeatureToggle();
    this.fillDeeplinkToggle();
  }

  componentDidMount() {
    this.getRecentFlights();
  }

  componentWillUnmount() {
    EventEmitter.removeListener(this.state.updateHistoryListener);
    EventEmitter.removeListener(this.state.modalInactivityListener);
  }

  componentWillReceiveProps(nextProps) {
    this.setFilter(nextProps);
  }

  fillDeeplinkToggle() {
    FeatureService.isFeatureEnabled(Features.HOME_SEARCH_DEEPLINK).then(isEnabled => {
      this.setState({
        isSearchDeeplinkEnabled: isEnabled
      });
    });
  }

  fillCallCenterModeFeatureToggle() {
    FeatureService.isFeatureEnabled(Features.CALLCENTER_MODE).then(isEnabled => {
      this.setState({
        isCallcenterEnabled: isEnabled
      });
      this.props.callbackCallcenterMode(isEnabled && isFromCallcenter());
    });
  }

  showModalInactivity = errorType => {
    let message = '';

    if (ErrorsCodes.CALLCENTER_ACCESS_DENIED_ERROR === errorType[0]) {
      this.setState({
        urlRedirect: '/?callcenter=false'
      });
      message = I18n.translate('home.msg.error');
    } else {
      this.setState({ modalInactivity: true });
      message = I18n.translate('home.msg.session.callCenterExpired');
      console.log("SearchBoxContainer: ",errorType[0])
    }

    this.showModal(message);
  };

  setFilter(filter) {
    this.setState({
      filterTypeTrip: filter.typeTrip,
      filterFlightOrigin: filter.flightOrigin,
      filterFlightDestiny: filter.flightDestiny,
      filterStartDate: filter.startDate,
      filterEndDate: filter.endDate,
      filterTotalAdults: filter.totalAdults,
      filterTotalKids: filter.totalKids,
      filterTotalBabys: filter.totalBabys,
      filterCabinCategory: filter.cabinCategory,
      filterTypeOfFlight: filter.typeOfFlight,
      filterCompaniesIdentity: filter.companiesIdentity
    });
  }

  handleRecentFlights() {
    this.setState({
      recentFlights: this.getRecentFlights()
    });
  }

  handleSearchWithAvailability(filter) {
    this.setFilter(filter);

    const reqfilter = {
      tripType: filter.typeTrip === 'roundTrip' ? 'ROUND_TRIP' : 'ONE_WAY',
      origin: filter.flightOrigin.code,
      destination: filter.flightDestiny.code,
      adult: filter.totalAdults,
      child: filter.totalKids,
      infant: filter.totalBabys
    };

    reqfilter.departureDateTime = MomentTZ(filter.startDate).format();
    if (filter.endDate) {
      reqfilter.returnDateTime = MomentTZ(filter.endDate).format();
    }

    const query = Object.keys(reqfilter)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(reqfilter[key]))
      .join('&');

    fetchLoader(GET_AVAILABILITY_V1 + query)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw Error();
        }
      })
      .then(responseJson => {
        this.updateCookies(filter);
        this.setState({
          isRedirect: true,
          urlRedirect: '/flights',
          result: responseJson,
          filter: filter
        });
      })
      .catch(error => {
        this.showModal(I18n.translate('home.msg.error'));
      });
  }

  handleAirportSearch(searchTerm, airport) {
    const reqfilter = {
      searchAirport: searchTerm
    };

    if (airport) {
      reqfilter.ignoreCode = airport.searchCode === '1N' ? '1N' : '';
      reqfilter.ignoreAirport = airport.code;
    }

    const query = Object.keys(reqfilter)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(reqfilter[key]))
      .join('&');

    return fetch(GET_AIRPORTS_V1 + query)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw Error();
        }
      })
      .catch(() => {
        this.showModal(I18n.translate('home.msg.error'));
        return [];
      });
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal() {
    if (this.state.modalInactivity && this.callCenterMode()) {
      document.location.assign(global.env.CALLCENTER_LOGOUT_URL);
    } else {
      this.setState({
        isRedirect: true,
        openModal: false,
        messageInfo: null
      });
    }
  }

  callCenterMode() {
    return this.state.isCallcenterEnabled && isFromCallcenter();
  }

  handleSearchDeeplink = filter => {
    let deepLink = this.buildDeeplink(filter);
    this.setState({
      urlRedirect: deepLink,
      isRedirect: true,
      filter: filter
    });
  };

  handleSearch = filter => {
    if (this.state.isSearchDeeplinkEnabled) {
      this.handleSearchDeeplink(filter);
    } else {
      this.handleSearchWithAvailability(filter);
    }
  };

  buildDeeplink(filter) {
    const typeTrip = filter.typeTrip === 'oneWay' ? 'OW' : 'RT';
    const startDate = Moment(filter.startDate).format('YYYY-MM-DD');
    const endDate = filter.endDate ? Moment(filter.endDate).format('YYYY-MM-DD') : '-';
    const flightOrigin = filter.flightOrigin.code;
    const flightDestiny = filter.flightDestiny.code;
    const typeOfFlight = filter.typeOfFlight !== null ? filter.typeOfFlight : 'A';
    const companiesIdentity = filter.companiesIdentity !== '' ? filter.companiesIdentity : '-';

    let deepLink = '';

    const cabinCategory = filter.cabinCategory;
    deepLink = `/flights/${typeTrip}/${flightOrigin}/${flightDestiny}/-/-/${startDate}/${endDate}/${
      filter.totalAdults
    }/${filter.totalKids}/${filter.totalBabys}/0/0/ALL/F/${cabinCategory}/-/-/-/-/${typeOfFlight}/${companiesIdentity}`;

    return deepLink;
  }

  getRecentFlights() {
    const { cookies } = this.props;
    const cookiesFlight = cookies.get(PREVIOUS_VISIT_COOKIE);
    FeatureService.isFeatureEnabled(Features.FLIGHT_HISTORY_SERVICE).then(isEnabled => {
      let recentFlights = [];
      if (isEnabled) {
        recentFlights = FlightHistoryService.getRecentFlights();
      } else {
        if (cookiesFlight) {
          cookiesFlight.split('#').forEach(flight => {
            if (flight) {
              const flightAttibutes = flight.split('|');
              recentFlights.push({
                typeTrip: flightAttibutes[0],
                flightOrigin: {
                  code: flightAttibutes[1],
                  searchCode: flightAttibutes[2],
                  name: flightAttibutes[3]
                },
                flightDestiny: {
                  code: flightAttibutes[4],
                  searchCode: flightAttibutes[5],
                  name: flightAttibutes[6]
                },
                startDate: flightAttibutes[7],
                endDate: flightAttibutes[8],
                totalAdults: Number(flightAttibutes[9]),
                totalKids: Number(flightAttibutes[10]),
                totalBabys: Number(flightAttibutes[11]),
                typeOfFlight: flightAttibutes[13] === 'D' ? true : false,
                companiesIdentity: flightAttibutes[14]
              });
            }
          });
        }
      }
      this.setState({
        recentFlights: recentFlights,
        isFlightHistoryEnabled: isEnabled
      });
    });
  }

  updateCookies(flightSearched) {
    if (this.state.isFlightHistoryEnabled) {
      FlightHistoryService.updateRecentFlights(flightSearched);
    } else {
      if (this.isRecentFlightUpdated(flightSearched, this.state.recentFlights[0])) {
        const newRecentFlights = this.state.recentFlights.slice();
        newRecentFlights.unshift(flightSearched);
        const newRecentFlightsCookie = newRecentFlights
          .slice(0, 3)
          .map(flight => this.getRecentFlightAsCookieString(flight))
          .reduce((a, b) => `${a}#${b}`);

        const { cookies } = this.props;
        cookies.set(PREVIOUS_VISIT_COOKIE, newRecentFlightsCookie, {
          path: '/',
          expires: Moment()
            .add(1, 'year')
            .toDate()
        });
        EventEmitter.emitEvent(Listener.RECENT_FLIGHTS);
        this.setState({
          recentFlights: newRecentFlights
        });
      }
    }
  }

  getRecentFlightAsCookieString(flight) {
    const typeTrip = `${flight.typeTrip}|`;
    const flightOrigin = `${flight.flightOrigin.code}|${flight.flightOrigin.searchCode}|${
      flight.flightOrigin.name
    }|`;
    const flightDestiny = `${flight.flightDestiny.code}|${flight.flightDestiny.searchCode}|${
      flight.flightDestiny.name
    }|`;
    const dates = `${flight.startDate}|${flight.endDate ? flight.endDate : ''}|`;
    const passengers = `${flight.totalAdults}|${flight.totalKids}|${flight.totalBabys}|`;
    return `${typeTrip}${flightOrigin}${flightDestiny}${dates}${passengers}`;
  }

  isRecentFlightUpdated(newFlight, oldFlight) {
    return (
      !oldFlight ||
      this.getRecentFlightAsCookieString(newFlight) !==
        this.getRecentFlightAsCookieString(oldFlight)
    );
  }

  render() {
    return (
      <div>
        <SearchBox
          typeTrip={this.state.filterTypeTrip}
          flightOrigin={this.state.filterFlightOrigin}
          flightDestiny={this.state.filterFlightDestiny}
          startDate={this.state.filterStartDate}
          endDate={this.state.filterEndDate}
          totalAdults={this.state.filterTotalAdults}
          totalKids={this.state.filterTotalKids}
          totalBabys={this.state.filterTotalBabys}
          cabinCategory={this.state.filterCabinCategory}
          typeOfFlight={this.state.filterTypeOfFlight}
          companiesIdentity={this.state.filterCompaniesIdentity}
          searchCallback={this.handleSearch}
          recentFlights={this.state.recentFlights}
          clickRecentSearch={this.props.loadRecentFlight}
          handleAirportSearch={this.handleAirportSearch}
          ref={e => (this.searchBox = e)}
        />
        <InfoModal
          id="modalSearchInfo"
          message={this.state.messageInfo}
          showModal={this.state.openModal}
          close={this.closeModal}
          ref={c => {
            this.modalSearchInfo = c;
          }}
        />

        {this.state.isRedirect ? (
          <Redirect
            push
            to={{
              pathname: this.state.urlRedirect,
              state: {
                result: this.state.result,
                filter: this.state.filter
              },
              search: this.props.location ? this.props.location.search : null
            }}
          />
        ) : null}
      </div>
    );
  }
}

SearchBoxContainer.propTypes = propTypes;
SearchBoxContainer.defaultProps = defaultProps;

export default withCookies(SearchBoxContainer);



// WEBPACK FOOTER //
// ./src/components/searchBoxContainer/SearchBoxContainer.jsx